import React, { useEffect, Suspense } from 'react';
// import { useAppDispatch, useAppSelector } from '../../../store/hooks';
// import { GetReportsList } from '../../../store/NTX/Reports/reportSlice';
// import ReportsAllByModule from '../../NTX/Reports/ReportsModule/Index';
import ReportsAllByModule from '../../../NTX/Reports/ReportsModule/Index';

import { v4 as uuidv4 } from 'uuid';
import ApLedgerTransactionsReport from './ApLedgerTransactionsReport';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { GetReportsList } from '@store/NTX/Reports/reportSlice';
import LazyLoading from '@config/LazyLoading/LazyLoading';

// استيراد المكونات باستخدام React.lazy
const InvoiceReconciliationReport = React.lazy(() => import('./InvoiceReconciliationReport'));
const AccountStatementReport = React.lazy(() => import('./AccountStatementReport'));
const AgingAnalysisReport = React.lazy(() => import('./AgingAnalysisReport'));
const OutstandingPayablesReport = React.lazy(() => import('./OutstandingPayablesReport'));
const SupplierPaymentsReport = React.lazy(() => import('./SupplierPaymentsReport'));
const SupplierPerformanceReport = React.lazy(() => import('./SupplierPerformanceReport'));
//
const RPT_PurchaseFlow = React.lazy(() => import('./RPT_PurchaseFlow'));

const SupplierAccountStatement_Paged = React.lazy(() => import('./SupplierAccountStatement_Paged'));

const SupplierPurLinkedGrouped_Paged = React.lazy(() => import('./SupplierPurLinkedGrouped_Paged'));

const PurchaseDetails_Paged = React.lazy(() => import('./PurchaseDetails_Paged'));

const PurTransactions_Paged = React.lazy(() => import('./PurTransactions_Paged')); // عدّل المسار حسب مكان ملفك

const ApInvoicesDetails_Paged = React.lazy(() => import('./ApInvoicesDetails_Paged')); // عدّل المسار حسب مكان ملفك

const ApSuppliersTotalBalances_Paged = React.lazy(() => import('./ApSuppliersTotalBalances_Paged')); // عدّل المسار حسب مكان ملفك

interface Report {
  id: string;
  name: string;
  name2: string;
  moduleId: string;
  tableName: string;
  query: string;
  description: string;
  pageType: string;
  reportType: string;
}

interface ReportsListState {
  ReportsList: Report[];
  loading: boolean;
}

//________________ Start Components
const ApReports: React.FC = () => {
  const dispatch = useAppDispatch();

  const { ReportsList, loading } = useAppSelector(state => state.Reports) as ReportsListState;
  useEffect(() => {
    dispatch(GetReportsList());
  }, [dispatch]);

  const reportListByModule = ReportsList?.filter(
    f => f.moduleId?.toLowerCase() === '0a6c6b89-1d52-4eaa-8d2c-052c74b1f6e0'
  );

  const PurReports = [
    // العناصر القادمة من النظام (تقارير مخصصة)
    ...(reportListByModule ?? []).map(report => ({
      ...report,
      type: 'custom',
      component: null // لا يوجد مكون ثابت
    })),

    // تقارير ثابتة إضافية
    // تقارير ثابتة إضافية
    {
      id: uuidv4(),
      name2: 'تقرير تسوية الفواتير',
      name: 'Invoice Reconciliation Report',
      icon: 'fas fa-file-invoice-dollar',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <InvoiceReconciliationReport />
        </Suspense>
      )
    },
    {
      id: uuidv4(),
      name2: 'تقرير مدفوعات الموردين',
      name: 'Supplier Payments Report',
      icon: 'fas fa-money-check-alt',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <SupplierPaymentsReport />
        </Suspense>
      )
    },
    {
      id: uuidv4(),
      name2: 'تقرير أداء الموردين',
      name: 'Supplier Performance Report',
      icon: 'fas fa-chart-line',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <SupplierPerformanceReport />
        </Suspense>
      )
    },
    {
      id: uuidv4(),
      name2: 'تقرير أعمار الديون',
      name: 'Aging Analysis Report',
      icon: 'fas fa-hourglass-half',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <AgingAnalysisReport />
        </Suspense>
      )
    },
    {
      id: uuidv4(),
      name2: 'تقرير الذمم الدائنة المستحقة',
      name: 'Outstanding Payables Report',
      icon: 'fas fa-exclamation-circle',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <OutstandingPayablesReport />
        </Suspense>
      )
    },
    {
      id: uuidv4(),
      name2: 'كشف حساب مورد',
      name: 'كشف حساب مورد',
      icon: 'fas fa-exclamation-circle',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <ApLedgerTransactionsReport />
        </Suspense>
      )
    },
    // {
    //   id: uuidv4(),
    //   name2: 'كشف حساب المورد',
    //   name: 'Supplier Account Statement Report',
    //   icon: 'fas fa-user-tie', // أيقونة المورد
    //   type: 'static',
    //   component: (
    //     <Suspense fallback={<LazyLoading />}>
    //       <SupplierAccountStatement_Paged />
    //     </Suspense>
    //   )
    // },
    // {
    //   id: uuidv4(),
    //   name2: 'متابعة أوامر الشراء',
    //   name: 'متابعة أوامر الشراء',
    //   icon: 'fas fa-exclamation-circle',
    //   type: 'static',
    //   component: (
    //     <Suspense fallback={<LazyLoading />}>
    //       <RPT_PurchaseFlow />
    //     </Suspense>
    //   )
    // },

    {
      id: uuidv4(),
      name2: 'مشتريات المورد المترابطة',
      name: 'Supplier Purchases Linked Grouped',
      icon: 'fas fa-link',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <SupplierPurLinkedGrouped_Paged />
        </Suspense>
      )
    },

    {
      id: uuidv4(),
      name2: 'تفاصيل المشتريات',
      name: 'تفاصيل المشتريات',
      icon: 'fas fa-link',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <PurchaseDetails_Paged />
        </Suspense>
      )
    },
    {
      id: uuidv4(),
      name: 'AP Invoices Details',
      name2: 'تفاصيل فواتير المدفوعات',
      icon: 'fas fa-file-invoice-dollar',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <ApInvoicesDetails_Paged />
        </Suspense>
      )
    },

    {
      id: uuidv4(),
      name: 'AP Suppliers Total Balances',
      name2: 'إجمالي أرصدة الموردين',
      icon: 'fas fa-users-cog',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <ApSuppliersTotalBalances_Paged />
        </Suspense>
      )
    }

    // {
    //   id: uuidv4(),
    //   name2: 'حركات المشتريات',
    //   name: 'Purchase Transactions',
    //   icon: 'fas fa-file-invoice', // مناسبة (فواتير/حركات مشتريات)
    //   type: 'static',
    //   component: (
    //     <Suspense fallback={<LazyLoading />}>
    //       <PurTransactions_Paged />
    //     </Suspense>
    //   )
    // },
  ];

  return (
    <>
      <ReportsAllByModule ReportsList={PurReports} loading={loading} reportType='both' />
    </>
  );
};

export default ApReports;
